import { render, staticRenderFns } from "./StudyQuizQuestionMedications.vue?vue&type=template&id=0a17b83f"
import script from "./StudyQuizQuestionMedications.vue?vue&type=script&lang=js"
export * from "./StudyQuizQuestionMedications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports